import { BulkPriceListUploadColumnKey, ColumnConfig } from '../model';

export const bulkPriceListUploadConfig: Record<
  BulkPriceListUploadColumnKey,
  ColumnConfig
> = {
  priceListName: { name: 'Price List Name' },
  code: { name: 'Code' },
  sku: { name: 'SKU' },
  productName: { name: 'Product Name' },
  price: { name: 'Price' },
  priceWithMargin: { name: 'Price With Margin' },
};
